import { render, staticRenderFns } from "./text-universal-credit.vue?vue&type=template&id=56131914&"
import script from "./text-universal-credit.vue?vue&type=script&lang=js&"
export * from "./text-universal-credit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports